module.exports = __webpack_public_path__ + "img/Tennessee outline.ae22ceb2.png";